<div class="forum-editor-container">
  <forum-editor-toolbar [options]="toolbarOptions" />

  <div
    #editorWrapper
    class="editor"
    [class.editor--drag-active]="isDragActive"
    (click)="focus()"
    (dragenter)="handleDragEnter($event)"
    (dragover)="handleDragOver($event)"
    (dragleave)="handleDragLeave($event)"
    (drop)="handleDrop($event)"
  >
    <div *ngIf="isEmpty" class="editor__placeholder">
      {{ placeholder | translate }}
    </div>
    <div #editorElement class="editor__content"></div>

    <div *ngIf="isDragActive" class="editor__drop-overlay">
      <file-upload
        class="file-upload-secondary editor__drop-upload"
        [maxFileSize]="attachmentConfig?.max_size || 26214400"
        [maxFiles]="100"
        [minFileSize]="1"
        [extensions]="attachmentConfig?.allowed_extensions || []"
        (codeFilesAdded)="handleDraggedAttachmentsSelected($event)"
      />
    </div>

    <div
      *ngIf="mentionCandidates.length"
      class="editor__mentions"
      [style.top.px]="mentionDropdownPosition.top"
      [style.left.px]="mentionDropdownPosition.left"
    >
      <forum-mentions-list
        [members]="mentionCandidates"
        [activeIndex]="activeMentionIndex"
        (selectMember)="selectMention($event)"
      />
    </div>
  </div>

  <input
    #attachmentInput
    type="file"
    class="attachment-input"
    multiple
    (change)="onAttachmentSelected($event)"
  />

  <div *ngIf="allAttachments.length" class="file-list-section">
    <file-list
      [files]="allAttachments"
      [removable]="true"
      (remove)="handleRemoveAttachment($event)"
    />
  </div>

  <p
    *ngIf="attachmentError"
    class="forum-editor__attachment-error text-body-sm"
  >
    {{ attachmentError }}
  </p>
</div>
